export const err = "companies/err";
export const req = "companies/req";
export const res = "companies/res";
export const update = "companies/update";
